<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="title"></a>CHAINS<br/>OF<br/>SAND</h1>
<p class="author">JEMMA WAYNE</p>
<p class="pub"><img alt="illustration" src="images/pub.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?687b81f7